import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {
  WBButton,
  WBForm,
  WBTextFieldV2,
  WBTypography,
} from '@admiin-com/ds-web';
import SimpleDrawDlg from '../SimpleDrawDlg/SimpleDrawDlg';
import { t } from 'i18next';
import { Controller, useForm } from 'react-hook-form';
import { REGEX } from '@admiin-com/ds-common';

export interface EmailAddressModalProps {
  open: boolean;
  onClose: () => void;
  onOK: (email: string) => Promise<void>;
  defaultEmail?: string;
  name: string;
  disabledEdit?: boolean;
}

function EmailAddressModal(props: EmailAddressModalProps) {
  const { onClose, open, onOK, defaultEmail, name } = props;
  const [loading, setLoading] = React.useState(false);
  const handleCancel = () => {
    onClose();
  };

  const isCreate = Boolean(defaultEmail) === false;

  const title = isCreate
    ? t('addContactEmailTitle', { ns: 'taskbox', contact: name })
    : t('editContactEmailTitle', { ns: 'taskbox', contact: name });
  const { control, handleSubmit } = useForm();
  const onSubmit = async (data: any) => {
    try {
      setLoading(true);
      await onOK(data.email);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <SimpleDrawDlg open={open} handleClose={onClose}>
      <WBForm onSubmit={handleSubmit(onSubmit)} mt={0}>
        <DialogTitle
          variant="h3"
          textAlign={'center'}
          sx={{ p: 0, color: 'text.primary' }}
        >
          {title}
          <WBTypography textAlign={'center'} color={'text.primary'}>
            {t('emailAddressDescription', { ns: 'taskbox' })}
          </WBTypography>
        </DialogTitle>
        <DialogContent sx={{ px: [2, 10] }}>
          <Controller
            control={control}
            name="email"
            defaultValue={defaultEmail}
            rules={{
              required: t('emailRequired', { ns: 'common' }),
              pattern: {
                value: REGEX.EMAIL,
                message: t('invalidEmail', { ns: 'common' }),
              },
            }}
            render={({ field, fieldState }) => (
              <WBTextFieldV2
                {...field}
                helperText={
                  fieldState.invalid ? t('invalidEmail', { ns: 'common' }) : ''
                }
                error={fieldState.invalid}
                margin="dense"
              />
            )}
          />
        </DialogContent>
        <DialogActions sx={{ width: '100%', px: [2, 10] }}>
          <WBButton
            autoFocus
            variant="outlined"
            onClick={handleCancel}
            fullWidth
            type="button"
          >
            {t('cancel', { ns: 'common' })}
          </WBButton>
          {!props.disabledEdit && (
            <WBButton type="submit" loading={loading} fullWidth>
              {t(isCreate ? 'add' : 'Save', { ns: 'common' })}
            </WBButton>
          )}
        </DialogActions>
      </WBForm>
    </SimpleDrawDlg>
  );
}
export default EmailAddressModal;
